/**
 * Vue Filter - Cornell Link
 */

/**
 * Return link to cornell website.
 *
 * @param {number} val Number value
 * @param {boolean} usePref Use prefix
 */


export default function cornellLink(title, section) {
	const sectionSplits = section?.match(/(\d+)([\w+]?)/)
	if (!sectionSplits) return `#`
	let [full, number, hash] = sectionSplits
	hash = hash ? hash.split(``).join(`_`) : hash

	return `https://www.law.cornell.edu/uscode/text/${title}/${full}#${hash}`
}
